var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quadia-player-app",class:{'full-height': _vm.fullHeight}},[(_vm.isPostermode)?_c('poster',{on:{"disabled":_vm.initAndPlay}}):_vm._e(),(_vm.showCustomErrorMessage)?_c('custom-error',{attrs:{"message":_vm.customErrorMessage}}):_vm._e(),(_vm.loaded)?_c('video-js-video'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }